<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <div v-for="(value, index) in typesList" :key="index">
                    <SeafarerDocumentArchiveTable
                        :inEditMode="true"
                        :reload="reload"
                        :seafarer="seafarer"
                        :category="value"
                    />
                </div>
            </v-col>
        </v-row>
        <v-row><v-col></v-col></v-row>
    </v-container>
</template>

<script>
import SeafarerDocumentArchiveTable from './SeafarerDocumentArchiveTable';

export default {
    name: 'SeafarerDocumentsArchive',
    components: {SeafarerDocumentArchiveTable},
    data: function () {
        return {
            initialLoad: false,
            languagesItems: [],
            lockKey: 'seafarer-document-archive',
            lockTimer: null,
            typesList: [],
            documentDialog: false,
        };
    },
    props: ['seafarer', 'inEditMode', 'reload'],
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        } else {
            let vm = this;
            this.$APICall('get', 'select/document-categories', {}, (data, succes) => {
                if (succes) {
                    vm.typesList = data;
                } else {
                    vm.$notify(vm.$t('alerts.basicError'));
                }
            });
            this.initialLoad = true;
        }
    },
};
</script>

<style scoped></style>
